import axios from "axios";
import { API_END_POINT } from "../../constants/api";

export const LOG_IN = "LOG_IN";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_SUCCESFULL = "LOGIN_SUCCESFULL";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAIL = "GET_CURRENT_USER_FAIL";

export const CLEAR_STATE = "CLEAR_STATE";
export const LOG_OUT = "LOG_OUT";
export const USER_DETAIL = "USER_DETAIL";

export function logout() {
  return { type: LOG_OUT };
}

export function login(userData) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify(userData);
    axios
      .post(`${API_END_POINT}/users/signin`, body, config)
      .then((res) => {
        console.log("response=>", res);
        dispatch({
          type: LOG_IN,
          payload: res.data,
        });
        dispatch({
          type: LOGIN_SUCCESFULL,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: LOGIN_FAIL,
          payload:
            err.response?.data?.message ||
            "Network error — check API connection",
        });
      });
  };
}

export function getProfile({ token }) {
  let AuthorizationToken = token;
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${AuthorizationToken}`,
      },
    };
    axios
      .get(`${API_END_POINT}/users/profile`, config)
      .then((res) => {
        console.log("response get profile=>", res);
        dispatch({
          type: GET_CURRENT_USER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_CURRENT_USER_FAIL,
          payload: err.response?.data?.message || "Failed to load profile",
        });
      });
  };
}

export function users(userDetails) {
  return (dispatch) => {
    dispatch({
      type: USER_DETAIL,
      payload: userDetails,
    });
  };
  // return {
  //   type: USER_DETAIL,
  //   payload: userDetails,
  // };
}

export function getCurrentUser(authToken) {
  return (dispatch) => {
    axios
      .get(`${API_END_POINT}/api/auth/me`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("response", response);

        dispatch({
          type: GET_CURRENT_USER,
          payload: response.data,
        });
      });
  };
}

export function clearState() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_STATE,
    });
  };
}
